module.exports = __webpack_public_path__ + "static/step-3-3e103cfe99c72fb02d5c2fa6c822e011.svg";